document.addEventListener("DOMContentLoaded", () => {
  const iframe = document.getElementById("vimeo-player");

  // Initialize the Vimeo Player instance
  const player = new Vimeo.Player(iframe);

  // Configure the observer to watch the video element
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Video is in view -> Play
        player.play().catch(error => {
          console.log("Autoplay prevented by browser:", error);
        });
      } else {
        // Video scrolled out of view -> Pause so it doesn't waste resources
        player.pause();
      }
    });
  }, {
    threshold: 0.5 // 0.5 means it triggers when 50% of the video is visible on screen
  });

  // Start observing the iframe
  observer.observe(iframe);
});